export const environment = {
  production: false,
  logoLogin: 'assets/img/paypiere_text_logo_dev.png',
  logoSidebar: 'assets/img/paypiere_text_logo_dev.png',
  logoAlt: 'Paypiere Dev',
  logoClass: 'img'
};
